// MUI Imports
import type { Theme } from '@mui/material/styles';

// Type Imports
import type { Settings } from '../contexts/settingsContext';
import type { Skin, SystemMode } from '../types';

import breakpoints from './breakpoints';
import colorSchemes from './colorSchemes';
import customShadows from './customShadows';
// Theme Options Imports
import overrides from './overrides';
import shadows from './shadows';
import spacing from './spacing';
import typography from './typography';
import '@fontsource/poppins/latin.css'; // Defaults to weight 400 with all styles included.

const theme = (settings: Settings, mode: SystemMode, direction: Theme['direction']): Theme => {
  return {
    direction,
    components: overrides(settings.skin as Skin),
    colorSchemes: colorSchemes(settings.skin as Skin),
    ...spacing,
    shape: {
      borderRadius: 6,
      customBorderRadius: {
        xs: 2,
        sm: 4,
        md: 6,
        lg: 8,
        xl: 10,
      },
    },
    breakpoints: breakpoints,
    shadows: shadows(mode),
    typography: typography('Poppins'),
    customShadows: customShadows(mode),
    mainColorChannels: {
      light: '0 0 0',
      dark: '231 227 252',
      lightShadow: '46 38 61',
      darkShadow: '19 17 32',
    },
  } as unknown as Theme;
};

export default theme;
